function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Accordion as AccordionBase, AccordionItem as AccordionItemBase, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, AccordionItemState } from 'react-accessible-accordion';
import Icon from '../icon';
import Card from '../cards/card';
import Chip from '../chip';
import Avatar from '../avatar';
import Body from '../typography/body';
import { size14, size16, size20, size64 } from '../theme/scale';
import { focusShadow, gray200, gray800 } from '../theme/colors';
import styled from 'styled-components';
import ColorWrapper from '../typography/color-wrapper';
import { fontSemiBold } from '../theme/fonts';
import AnimateHeight from 'react-animate-height';
const Wrapper = styled(Card)`
  flex-direction: row;
  min-width: ${({
  minWidth
}) => minWidth};
`;
export const Label = styled(ColorWrapper)`
  font-family: ${fontSemiBold};
  font-size: ${size16};
  line-height: 1.5;
`;
export const Accordion = ({
  children,
  onChange,
  minWidth = '280px',
  allowMultipleExpanded = false,
  preExpanded = [],
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    elevation: "3",
    padding: "0",
    minWidth
  }, props), /*#__PURE__*/React.createElement(AccordionBase, {
    allowZeroExpanded: true,
    onChange: onChange,
    allowMultipleExpanded,
    preExpanded
  }, children));
};
const ItemWrapper = styled(AccordionItemBase)`
  &:not(:last-child) {
    border-bottom: 1px solid ${gray200};
  }
  &:focus-within {
    outline: none;
    box-shadow: 0 0 0 3px ${focusShadow};
  }
`;
const Title = styled(Body)`
  font-family: ${fontSemiBold};
  font-size: ${size16};
  line-height: 1.5;
  margin-left: ${({
  name,
  src,
  type
}) => name || src || type ? size14 : 0};
  color: ${gray800};
  margin-right: auto;
`;
const Content = styled(AccordionItemButton)`
  min-height: ${size64};
  padding: ${size20};
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
const AccordionPanel = styled(AccordionItemPanel)`
  padding: 0 ${size20} ${size20};
`;
const HighlightChip = styled(Chip)`
  margin: 0 ${size20};
`;
export const AccordionItem = ({
  children,
  title,
  id,
  highlightMessage,
  type,
  src,
  name
}) => {
  return /*#__PURE__*/React.createElement(ItemWrapper, {
    uuid: id
  }, /*#__PURE__*/React.createElement(AccordionItemState, null, ({
    expanded
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccordionItemHeading, null, /*#__PURE__*/React.createElement(Content, null, name || src ? /*#__PURE__*/React.createElement(Avatar, {
    size: "xs",
    name,
    src
  }) : type && /*#__PURE__*/React.createElement(Icon, {
    size: 16,
    color: "gray600",
    type
  }), /*#__PURE__*/React.createElement(Title, {
    name,
    src,
    type,
    as: "span"
  }, title), highlightMessage && /*#__PURE__*/React.createElement(HighlightChip, {
    message: highlightMessage,
    rounded: false,
    variant: "teal-inverse",
    filled: true
  }), /*#__PURE__*/React.createElement(Icon, {
    color: "gray600",
    size: 28,
    type: expanded ? 'ChevronUp' : 'ChevronDown'
  }))), /*#__PURE__*/React.createElement(AnimateHeight, {
    duration: 300,
    height: expanded ? 'auto' : 0,
    style: {
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement(AccordionPanel, null, children)))));
};
//# sourceMappingURL=index.js.map